/**
 * @since 7.1.0
 */
export interface OpenCalendarOptions {
  /**
   * @default Date.now()
   * @since 7.1.0
   */
  date: number;
}
